import ChaptersCollection from 'collections/ChaptersCollection'

export default class ModuleModel extends Backbone.Model {

    preinitialize() {
        this.constructor.type = 'module'
        this.constructor.pluralType = 'modules'
    }

    initialize(data, {groupModel}) {
        this.groupModel = groupModel
    }

    getParent() {
        return this.getGroupModel()
    }

    getChildren() {
        return new ChaptersCollection(
            this.getGroupModel().chapters.where({moduleId: this.id})
        )
    }

    getSiblings() {
        return this.getGroupModel().modules
    }

    getGroupModel() {
        return this.groupModel
    }

    getModuleModel() {
        return this
    }

    getCrumblepathModel() {
        return new Backbone.Model({
            icon: this.getIcon(),
            label: this.get('title'),
            index: '',
            level: 'groups',
            path_id: `${this.getGroupModel().id}?module=${this.id}`,
        })
    }

    getAllCrumblepathModels() {
        return [
            this.getGroupModel().getCrumblepathModel(),
            this.getCrumblepathModel()
        ]
    }

    setSequence() {
        this.set({
            sequence: this.id === 0 ?
                Infinity :
                this.getGroupModel().chapters.find({moduleId: this.id}).get('sequence'),
        })
    }

    // Modules do not support content domains
    getContentDomain() {}

    getIcon() {
        if (this.id === 0) {
            return 'arrow-forward'
        }
        return 'module'
    }

}
